import type {FC} from 'react';

import type {Props} from './types';

import * as S from './styles';

export const OptionButton: FC<Props> = ({icon, isActive, label, ...rest}) => {
  return (
    <S.Container {...rest} $isActive={isActive}>
      <S.Icon $isActive={isActive} component={icon} />
      <S.Label $isActive={isActive}>{label}</S.Label>
    </S.Container>
  );
};
